import { useMemo } from 'react'

import { Icon, IconButton, Loader, Text } from 'components'

import { useTenant } from 'shared/hooks'

import { useGetPaymentMethod } from 'services/patrimony'
import { useNavigate, useParams } from 'react-router-dom'

import { handleRenderState } from 'utilities/handleRenderState'

import styles from './styles.module.scss'

const PendingAccounts = () => {
  const { tenant } = useTenant()
  const { userId } = useParams()

  const navigate = useNavigate()

  const {
    data: patrimonies,
    isError,
    isFetching,
  } = useGetPaymentMethod(userId || '')

  const pendingAccounts = useMemo(
    () =>
      patrimonies
        ?.map((patrimony) => ({
          ...patrimony,
          accounts: patrimony.accounts.filter(
            (account) => !account?.paymentMethod,
          ),
        }))
        .filter((patrimony) => patrimony?.accounts?.length),
    [patrimonies],
  )

  return (
    <>
      {
        {
          view: (
            <div className={styles.container}>
              <header className={styles.header}>
                <IconButton
                  className={styles.navigation}
                  onClick={() => navigate(-1)}
                >
                  <Icon
                    width={20}
                    name="chevron-sm-left"
                    color="element-default"
                  />
                </IconButton>
                <Icon
                  url={tenant?.brand?.images?.horizontalLogo}
                  width={151}
                  height={28}
                />
              </header>

              <div className={styles.wrapper}>
                <div>
                  <Text
                    as="h2"
                    weight="semibold"
                    size="3xl"
                    color="element-bold"
                  >
                    Contas sem forma de pagamento
                  </Text>

                  <div className={styles.listContainer}>
                    {pendingAccounts
                      ?.sort((a, b) => a.name.localeCompare(b.name))
                      .map((patrimony) => (
                        <div key={patrimony.id}>
                          <div className={styles.patrimony}>
                            <Text size="lg" weight="semibold">
                              {patrimony.name}
                            </Text>
                            <Text size="sm">{patrimony.address.address}</Text>
                          </div>
                          <div className={styles.optionContainer}>
                            {patrimony.accounts.map((account) => (
                              <div key={account.id}>
                                <div className={styles.selected}>
                                  <div>
                                    <Text
                                      size="md"
                                      weight="regular"
                                      color="element-default"
                                    >
                                      {`${account.code} - ${account.name}`}
                                    </Text>
                                  </div>

                                  <IconButton
                                    onClick={() =>
                                      navigate(
                                        `/payment-method/${userId}?patrimonyId=${patrimony.id}&accountId=${account.id}`,
                                      )
                                    }
                                  >
                                    <Icon
                                      width={17}
                                      name="chevron-sm-right"
                                      color="element-default"
                                    />
                                  </IconButton>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          ),
          empty: <></>,
          loading: <Loader appearance="screen" />,
          error: (
            <div className={styles.error}>
              <Icon
                width={44}
                height={62}
                name="phone"
                color="element-default"
              />
              <Text size="lg" weight="semibold">
                Erro ao carregar
              </Text>
              <Text size="sm" weight="regular">
                Ocorreu um problema inesperado. Feche o navegador e abra
                novamente para tentar outra vez.
              </Text>
            </div>
          ),
        }[
          handleRenderState({
            data: pendingAccounts,
            isEmpty: !pendingAccounts?.length,
            isLoading: isFetching,
            isError,
          })
        ]
      }
    </>
  )
}

export default PendingAccounts
